// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — info-block.styled.classic.js, новая — info-block.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './info-block.styled.classic';
import * as cp from './info-block.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const CallsCount = isCp ? cp.CallsCount : classic.CallsCount;
export const InfoGroup = isCp ? cp.InfoGroup : classic.InfoGroup;
export const InfoWrapper = isCp ? cp.InfoWrapper : classic.InfoWrapper;
export const Separator = isCp ? cp.Separator : classic.Separator;
export const Signals = isCp ? cp.Signals : classic.Signals;
export const SignalsCount = isCp ? cp.SignalsCount : classic.SignalsCount;
